import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AiMessage } from '../../models';
import { AdImagePreviewDialogComponent } from '../../../../_core/state/ad/ad-preview/ad-image-preview-dialog/ad-image-preview-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
	selector: 'app-ai-photo-grid-renderer',
	templateUrl: './photo-grid-renderer.component.html',
	styleUrls: ['./photo-grid-renderer.component.scss']
})
export class PhotoGridRendererComponent {
	@Input() message!: AiMessage; // expects content: { items: { id: string; url: string; thumbUrl?: string; added?: boolean }[] }
	@Output() action = new EventEmitter<{ type: string; itemId?: string; itemIds?: string[]; item?: any, items?: any[] }>();
	@Input() addedIds: string[] = [];

	constructor(
		private readonly dialog: MatDialog
	){}

	isAdded(item: any): boolean {
		const ids = this.addedIds instanceof Set ? this.addedIds : new Set(this.addedIds as string[]);
		return ids.has(item?.id);
	}

	isAllAdded(items: any): boolean {
		const ids = this.addedIds instanceof Set ? this.addedIds : new Set(this.addedIds as string[]);
		return items.every((item: any) => ids.has(item.id));
	}

	add(item: any) {
		this.action.emit({type: 'add', itemId: item.id, item: this.normalizeItem(item)});
		this.addedIds.push(item.id);
	}

	addAll(items: any[]) {
		const alreadyAdded = this.addedIds instanceof Set ? this.addedIds : new Set(this.addedIds as string[]);
		const itemsToAdd = (items || []).filter((i: any) => !alreadyAdded.has(i.id)).map(i => this.normalizeItem(i)) || [];
		const itemIds = itemsToAdd.map((i: any) => i.id);

		this.action.emit({type: 'add-all', itemIds, items: itemsToAdd} as any);
		this.addedIds.push(...itemIds);

	}

	openPreview(item: any) {
		this.dialog.open(AdImagePreviewDialogComponent, {
			data: {
				assetPath: item.thumbUrl || item.url || (item.b64 ? ('data:image/png;base64,' + item.b64) : null),
				title: item.id
			},
			panelClass: ['mat-dialog-no-padding']
		});
	}

	private normalizeItem(item: any): any {
		return {
			...item,
			title: `ai-generated-${item.id}.png`,
			mimeType: 'image/png',
		}
	}
}
